import React from "react";
import styles from "./styles.module.css";
import NoSSR from "@components/utils/NoSSR";
import { format, addDays, getDay, nextMonday } from "date-fns";
import { ru } from "date-fns/locale";

const Intro = ({ title, tutor, video, order }) => {
  function getValidDay(date) {
    const number = getDay(date);
    if (number === 0) {
      return 6;
    }

    return number;
  }

  function formatDisplay(date) {
    return format(date, "d MMMM", { locale: ru });
  }

  function getStartCourseDate(currentDate, courseStartDay) {
    let result = currentDate;
    if (getValidDay(currentDate) > courseStartDay + 1) {
      result = nextMonday(result);
      return addDays(result, courseStartDay);
    }

    return addDays(result, courseStartDay - getValidDay(currentDate) + 1);
  }
  return (
    <>
      <NoSSR>
        <div className={styles.heading} id="up">
          <div>
            <h1 className={styles.title}>БУТКЕМП: {title}</h1>
            <h2 className={styles.tutor}>{tutor}</h2>
            <h3 className={styles.job}>
              <span>
                Старт {formatDisplay(getStartCourseDate(new Date(), order - 1))}
              </span>
            </h3>
          </div>
        </div>

        {video && (
          <div className={styles.video}>
            <div style={{ padding: "62.25% 0 0 0", position: "relative" }}>
              <iframe
                src={video}
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  width: "100%",
                  height: "100%",
                }}
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        )}
      </NoSSR>
    </>
  );
};

export default Intro;
